export const exitTheSystem="是否确定要退出系统？";
export const onlyAvailable1="此功能只能在纳税人状态正常时使用。";
export const onlyAvailable2="此功能只能在纳税人分支状态正常时使用。";
export const onlyAvailable3="此功能只能在纳税人分支的E-invoicing状态正常时使用。";
export const canNotIssue="您不能通过该渠道开票，请联系税局人员。";
export const pleaseRegisterFirst="请先登记";
export const english="English";
export const chinese="中文";
export const siteMap="站点地图";
export const contactUs="联系我们";
export const guideline="My-invoice 指引";
export const searchPolicy="政策法规与常见问题查询";
export const searchFunction="功能查询";
export const viewProfile="个人中心";
export const language="Language";
export const next="下一页";
export const skip="跳过";
export const policy="政策法规";
export const yes="确定";
export const no="取消";
export const logout="退出登录";
export const publicMenuArea="公共菜单区域";
export const home="首页";
export const eInvoicing="发票开具";
export const performance="图形展示";
export const userGuides="用户指南";
export const FAQs="常见问题";
export const leftMenu="左侧菜单：主操作功能区";
export const message="消息：查看收到的消息";
export const visitorNumber="访问次数：";
export const lastUpdate="上次更新：";
export const upToDate="您的设备/e-Invoicing状态是否需要更新？";
export const title="标题";
export const summary="摘要";
export const source="来源";
export const releaseDate="发布日期";
export const enterBusinessSystemOrRemarks="输入业务系统或备注";
export const myCompany="公司";
export const maintainTheBusinessSystem="请维护业务系统。";
export const idTypeNotMatchTIN="证照类型或证照号码与TIN不匹配。";
export const selectTheBusinessSystem="请选择业务系统。";
export const notCustomizedTemplate="您尚未定制PDF，请联系MyInvoice2U。";
